const openQuickShopModal = (product) => {
  // The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
  // You can check the values by logging it.
  console.log(product);
  
  // Add product to cart and open slide cart
  if (product && product.handle) {
    // First, we need to get the product data from Shopify
    fetch(`/products/${product.handle}.js`)
      .then(response => response.json())
      .then(productData => {
        // Get the first available variant (you might want to modify this logic based on your needs)
        const firstVariant = productData.variants.find(variant => variant.available);
        
        if (firstVariant) {
          // Add the product to cart using Shopify's cart API
          const formData = {
            'items': [{
              'id': firstVariant.id,
              'quantity': 1
            }]
          };
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => {
            console.log('Product added to cart:', data);
            
            // Update the slide cart to reflect the new item
            window.SLIDECART_UPDATE();
            
            // Open the slide cart
            window.SLIDECART_OPEN();
          })
          .catch(error => {
            console.error('Error adding product to cart:', error);
          });
        } else {
          console.error('No available variant found for product:', product.handle);
        }
      })
      .catch(error => {
        console.error('Error fetching product data:', error);
      });
  } else {
    console.error('Product handle is not available');
  }
}

// This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick = () => {
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
    (o) => {
      o.product && o.product.handle ? openQuickShopModal(o.product) : console.error("Product handle is not available in the event");
    },
    { disableDefault: !0 },
  );
}

window.tolstoyWidget ? subscribeToQuickShopClick() : window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);